import { cva } from 'class-variance-authority';

export const cvaAddPlacePageForm = cva([
  'AddPlacePageStyles-cvaAddPlacePageForm',
  'flex flex-col gap-1.2',
  'mt-1.2',
  'text-m-sb text-cGray',
]);

export const cvaAddPlacePageInput = cva([
  'AddPlacePageStyles-cvaAddPlacePageInput',
  'p-1.2',
  'text-l-b',
  'disabled:opacity-90 disabled:bg-[#252331]',
]);

export const cvaAddPlacePageSubtitle = cva([
  'AddPlacePageStyles-cvaAddPlacePageInput',
  'mt-2.4',
  'text-l-b text-cWhite',
]);

export const cvaAddPlacePageErrorMessage = cva([
  'AddPlacePageStyles-cvaAddPlacePageInput',
  'text-m-sb text-cRed',
  'mt-0.4',
]);
